/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface ScheduleSettingOptions {
  readonly intervalMinimumOption?: number;
  readonly intervalMaximumOption?: number;
  readonly hoursMinimumOption?: number;
  readonly hoursMaximumOption?: number;
  readonly minutesMinimumOption?: number;
  readonly minutesMaximumOption?: number;
  meridiemOptions?: Array<string> | null;
  readonly daysMinimumOption?: number;
  readonly daysMaximumOption?: number;
  readonly weekDayOptions?: Array<string> | null;
  readonly monthOptions?: Array<string> | null;
}
